// CreditsExplainer
import React from 'react';
import { getLocalImageUrl } from 'utils/image';
import styles from './CreditsExplainer.module.sass';

export interface CreditsExplainerProps {}

const CREDIT_USAGE = [
  {
    icon: 'movie',
    description:
      'Hire creators! 5 photos or 2 videos delivered per creator hired. See content creator levels below',
  },
  {
    icon: 'network',
    description: 'Get access to our entire, hand-picked creator network',
  },
  {
    icon: 'headset',
    description:
      'Have a dedicated account manager with a 1 on 1 strategy session',
  },
];

const CreditsExplainer: React.FC<CreditsExplainerProps> = ({}) => {
  return (
    <aside className={styles.creditsExplainer}>
      <h2>All credit packs include</h2>
      <ul className={styles.explainerRow}>
        {CREDIT_USAGE.map(({ icon, description }) => (
          <li className={styles.creditTip} key={icon}>
            <img
              src={getLocalImageUrl(`/images/add-credits/${icon}-icon.svg`)}
              alt=""
            />
            <p>{description}</p>
          </li>
        ))}
      </ul>
    </aside>
  );
};

export default CreditsExplainer;
